import { useState, useEffect, useCallback } from 'react';
import { getSentTracks } from '../../api/spotify.api';

export function useSentTracks(roomId) {
  const [sent, setSent]             = useState([]);
  const [nowPlaying, setNowPlaying] = useState(null);
  const [ready, setReady]           = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await getSentTracks(roomId);
      setSent(data.sent);
      setNowPlaying(data.nowPlaying);
    } catch {
      /* se reintenta en el próximo poll */
    } finally {
      setReady(true);
    }
  }, [roomId]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 15000);
    return () => clearInterval(id);
  }, [refresh]);

  return { sent, nowPlaying, ready, refresh };
}
